import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { isEventLiked } from '@/js/lib/api/v1/event';
import { useUserStore } from './user';
import { pinia } from '.';

const userStore = useUserStore(pinia);

export const useEventStore = defineStore('event', () => {
  const likedEventIds = ref<number[]>([]);

  async function checkLiked(eventIds: number[]) {
    if (userStore.isAuthenticated) {
      const likedList = await isEventLiked({ eventIds });
      likedEventIds.value = uniq([...likedEventIds.value, ...likedList.filter((event) => event.liked === 1).map((event) => Number(event.eventId))]);
    }
  }
  function addLiked(eventId: number) {
    if (!likedEventIds.value.includes(eventId)) {
      likedEventIds.value.push(eventId);
    }
  }
  function removeLiked(eventId: number) {
    likedEventIds.value.splice(likedEventIds.value.indexOf(eventId), 1);
  }

  return { likedEventIds: readonly(likedEventIds), checkLiked, addLiked, removeLiked };
});
